<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="competitivegoodsList" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>				
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		<competitivegoods-form ref="competitivegoodsForm" :data="currentrow" @success="submitSuccess" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import competitivegoodsForm from './form.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '任务',
				modal_width:1000,
				modal_height:500,
				currentrow:{},
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						field: 'id',
						title: '任务ID',
					},
					{
						field: 'name',
						title: '任务名称',
					},
					// {
					// 	field: 'status',
					// 	title: '状态',
					// 	formatter: ''
					// },
					{
						field: 'process',
						title: '进度(%)',
						formatter: ''
					},
					{
						field: 'staffid',
						title: '创建人',
						formatter: 'staff'
					},
					{
						field: 'create_time',
						title: '创建时间',
						formatter: 'datetime'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 150,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.export(row)}}>导出</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			add(){
				this.currentrow = {}
				this.$nextTick(()=>{
					this.$refs.competitivegoodsForm.modal_show()
				})
			},
			del(row) {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.competitivegoodstask.delete(row.id).then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.$refs.competitivegoodsList.commitProxy('query')
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			export(row){
				this.$api.competitivegoodstask.export({id:row.id}).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
				})
			},
			edit(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.competitivegoodsForm.modal_show()
				})
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = true
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.competitivegoodstask.list({
						...page,
						...updateForm,
						...other,
					}).then((res)=>{
						resolve(res)
					})
				})
			},
			submitSuccess(){
				this.$refs.competitivegoodsList.commitProxy('query')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			competitivegoodsForm	
		}
	}
</script>